import { Link } from 'react-router-dom';

import exploreIcon from '../../../utils/icons/explore-icon.png';

import brandImg1 from '../../../utils/images/cosmos_logo-black.png';
import brandImg2 from '../../../utils/images/ambience-logo.png';
import brandImg3 from '../../../utils/images/immersive_logo.jpg';
import brandImg4 from '../../../utils/images/Ciana_logo 1.png';

import './homepage.css';


const PartnershipSection = () => {
    return (
        <section className='partner-section sponsorship-section px-3 my-0 my-md-5 py-0 py-md-5'>
            <h2 className="text-center text-uppercase pt-5">Partner With Us</h2>
    
            <section className="sponsorship-brands d-flex flex-wrap justify-content-center my-md-5 my-sm-0 gap-3 gap-md-5">
                <div className="sponsor-card sponsor-card1">
                    <img src={brandImg1} alt="brand-image" width='100%' />
                </div>
                <div className="sponsor-card sponsor-card2">
                    <img src={brandImg2} alt="brand-image" width='100%' />
                </div>
                <div className="sponsor-card sponsor-card4">
                    <img src={brandImg4} alt="brand-image" width='100%' />
                </div>
                <div className="sponsor-card sponsor-card3">
                    <img src={brandImg3} alt="brand-image" width='100%' height='100%'/>
                </div>
            </section>
    
            <section className='d-flex justify-content-md-end justify-content-center align-items-center my-4 my-md-5 mb-5 pb-0 pb-md-5'>
                <a href='https://forms.gle/fjFbG7SC6E4ijkJx7' rel="noopener noreferrer"  target='_blank' className='customBtn text-uppercase'> <span>Partner With Us</span> <img src={exploreIcon} alt="" /></a>
            </section>
        </section>
      )
}

export default PartnershipSection